import React from 'react'
import PropTypes from 'prop-types'
import CustomSpin from '../elements/CustomSpin'

function CenterSpin(props) {
  const {fontSize} = props
  return (
    <div
      style={{
        textAlign: 'center',
        borderRadius: '4px',
        fontSize,
      }}>
      <CustomSpin {...props}>{props.children}</CustomSpin>
    </div>
  )
}

CenterSpin.propTypes = {fontSize: PropTypes.number}
CenterSpin.defaultProps = {fontSize: 25}

export default CenterSpin
